export const siteInfo = {
  name: '开云体育',
  fullName: '开云体育竞技平台',
  slogan: '畅享体育精彩，尽在开云体育',
  description: '开云体育是广大体育竞技爱好者的首选平台，提供最新官方网址直达入口、安全登录通道及完整体育赛事服务。汇聚海量体育赛事、专业数据分析与丰厚的活动福利，致力于为每一位用户打造极致的体育娱乐体验。',
  domain: 'https://kaixinhappy.cn',
  founded: '2016',
  contact: {
    email: 'service@kaiyunsports.com',
    phone: '400-888-6666',
    workingHours: '周一至周日 9:00 - 24:00',
  },
  stats: [
    { label: '平台用户', value: '500万+' },
    { label: '日均赛事', value: '3000+' },
    { label: '合作赛事', value: '200+' },
    { label: '运营年限', value: '8年+' },
  ],
  features: [
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠',
      description: '采用国际领先的SSL加密技术，全方位保障用户信息与资金安全，提供多重防护机制。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速体验',
      description: '全球CDN加速节点覆盖，页面加载迅速，赛事数据实时更新，让您快人一步掌握赛况。',
    },
    {
      icon: 'ri-football-line',
      title: '赛事丰富',
      description: '覆盖足球、篮球、网球、电竞等200+热门赛事，每天超过3000场比赛供您选择。',
    },
    {
      icon: 'ri-gift-line',
      title: '福利丰厚',
      description: '新用户注册即享专属礼包，日常签到、充值返利、节日活动等多重优惠持续放送。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      description: '完美支持PC端、移动端、平板等多种设备，随时随地畅享体育精彩，无缝切换不卡顿。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '全天客服',
      description: '7x24小时专业客服团队在线，快速响应各类问题，为您提供贴心周到的服务体验。',
    },
  ],
  brandValues: [
    {
      title: '诚信为本',
      description: '始终坚持公平、公正、公开的运营理念，以用户信任为基石，以诚信经营赢得市场口碑。自2016年成立以来，无任何不良记录，深受广大用户的信赖与好评。',
    },
    {
      title: '技术驱动',
      description: '汇聚顶尖技术团队，自主研发高性能交易系统与数据分析平台。采用分布式架构和实时流计算技术，确保毫秒级响应速度，为用户提供流畅稳定的服务。',
    },
    {
      title: '用户至上',
      description: '以用户需求为导向，不断优化产品体验。从注册到使用，从充值到提现，每一项流程都经过精心设计，力求让每位用户感受到便捷与贴心。',
    },
    {
      title: '责任担当',
      description: '积极履行企业社会责任，倡导理性娱乐理念。设立用户保护基金，提供自我约束工具，帮助用户建立健康的娱乐习惯，营造绿色和谐的平台环境。',
    },
  ],
  faqs: [
    {
      question: '如何找到开云体育最新网址？',
      answer: '由于网络环境变化，开云体育网址可能会定期更新。建议您收藏本页面，我们将第一时间更新最新官方网址入口，确保您能快速直达平台。您也可以通过关注我们的官方社交媒体账号获取最新网址信息。',
    },
    {
      question: '开云体育注册需要哪些信息？',
      answer: '注册开云体育账号非常简单，只需提供手机号码并设置登录密码即可完成注册。注册成功后，建议您完善个人资料并设置安全问题和绑定邮箱，以增强账户安全性。整个注册流程大约需要1-2分钟。',
    },
    {
      question: '开云体育支持哪些充值方式？',
      answer: '开云体育支持多种便捷的充值方式，包括银行卡转账、微信支付、支付宝、USDT加密货币等。充值实时到账，无需等待，且不收取任何充值手续费。最低充值金额灵活，满足不同用户的需求。',
    },
    {
      question: '开云体育如何保障资金安全？',
      answer: '开云体育采用银行级SSL加密技术和多重防火墙防护，所有交易数据均经过严格加密处理。平台资金由第三方金融机构托管，确保用户资金独立存放。同时设有风险监控系统，7x24小时实时监测异常交易。',
    },
    {
      question: '开云体育有哪些优惠活动？',
      answer: '开云体育为不同阶段的用户准备了丰富的优惠活动。新用户注册即享首充礼包和免费体验金；老用户可参与每日签到、充值返利、邀请好友等常规活动；在重大赛事和节假日期间，还会推出限时加码福利。',
    },
    {
      question: '开云体育平台支持哪些体育项目？',
      answer: '开云体育平台涵盖了全球主流体育项目，包括足球（英超、西甲、欧冠等）、篮球（NBA、CBA等）、网球（ATP、WTA等）、电竞（LOL、DOTA2等）、F1赛车、拳击、斯诺克等200+赛事类型，满足不同体育爱好者的需求。',
    },
    {
      question: '遇到问题如何联系客服？',
      answer: '开云体育提供7x24小时全天候客服支持。您可以通过在线客服聊天窗口、客服热线400-888-6666或发送邮件至service@kaiyunsports.com与我们联系。我们的专业客服团队将在最短时间内为您解决问题。',
    },
    {
      question: '开云体育网址打不开怎么办？',
      answer: '如果遇到网址打不开的情况，建议您尝试以下方法：1）清除浏览器缓存和Cookies后重试；2）尝试切换网络环境（如切换WiFi/移动数据）；3）检查本页面是否有最新网址更新；4）联系客服获取最新可用网址。',
    },
  ],
};

export const socialLinks = [
  { icon: 'ri-wechat-line', name: '微信公众号', href: '#' },
  { icon: 'ri-weibo-line', name: '微博', href: '#' },
  { icon: 'ri-telegram-line', name: 'Telegram', href: '#' },
];